// components/ui/SectionHeader.tsx
// Replaces the old dark-panel section header.
// Usage: <SectionHeader numeral="III" title="Estate position" />

import React from 'react';

interface SectionHeaderProps {
    numeral: string;               // 'I', 'II', 'III'...
    title: string;
    subtitle?: string;
    className?: string;
}

export function SectionHeader({ numeral, title, subtitle, className = '' }: SectionHeaderProps) {
    const hasNumeral = numeral.trim().length > 0;
    return (
        <div className={`section-header mb-5 pb-2 border-b border-[#E8E4DB] ${className}`}>
            <div className="flex items-baseline gap-3">
                {hasNumeral && (
                    <span className="section-header-numeral font-serif italic text-[18px] text-[#3730A3]">{numeral}.</span>
                )}
                <h2 className="section-header-title font-serif text-[22px] font-normal tracking-[-0.01em] text-[#1A1A1A] m-0">
                    {title}
                </h2>
            </div>
            {subtitle && (
                <div className={`mt-1 ${hasNumeral ? 'pl-[30px]' : ''} text-[13px] text-[#6B6762]`}>
                    {subtitle}
                </div>
            )}
        </div>
    );
}
